import React from 'react';
import { DynamicQuestionMulti } from './DynamicQuestionMulti';
import { DynamicQuestionSingle } from './DynamicQuestionSingle';
import { DynamicQuestionFreetext } from './DynamicQuestionFreetext';

export const DynamicQuestion = ({
    question,
    answer,
    truth,
    disabled,
    onChange
}) => {
    switch (question.type) {
        case 'single':
            return <DynamicQuestionSingle question={question} answer={answer} truth={truth} disabled={disabled} onChange={onChange}/>;
        case 'multi':
            return <DynamicQuestionMulti question={question} answer={answer} truth={truth} disabled={disabled} onChange={onChange}/>;
        case 'freetext':
            return <DynamicQuestionFreetext question={question} answer={answer} truth={truth} disabled={disabled} onChange={onChange}/>;
        case 'annotation':
            return <div><div className="fs-20 fw-semi-bold" style={{whiteSpace: 'pre-line'}}>{question.name}</div></div>
        default:
            return null;
    }
};
